import { SCREEN_ROUTER } from "../constants/screenRouter";
import { STORAGE_KEY } from "../constants/storageKeys"
import { getLocalStorage } from "./localStorage"
const nextScreen = (currenScreen) => {
    const cookieInfo = getLocalStorage(STORAGE_KEY.COOKIE_INFO);
    const playerInfo = getLocalStorage(STORAGE_KEY.PLAYER_INFO)
    const tokenInfo = getLocalStorage(STORAGE_KEY.LOGIN_TOKEN);
    const userInfo = getLocalStorage(STORAGE_KEY.USER_INFO);
    // console.log('nextScreen', tokenInfo)
    // console.log('nextScreen', playerInfo)
    // console.log('nextScreen',playerInfo)
    if (tokenInfo == null) {
        return SCREEN_ROUTER.LOGIN_TOKEN;
    }
    if (playerInfo != null) {
        return SCREEN_ROUTER.DASH_BOARD
    }
    if (tokenInfo != null && currenScreen === SCREEN_ROUTER.LOGIN_TOKEN) {
        return SCREEN_ROUTER.LOGIN_METHOD
    }
    return currenScreen
}

export default nextScreen